import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for the My Website builder (/studio). Anchors live in StudioBuilder.tsx. */
export function getStudioTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Build your website',
        description:
          "This is your website builder. Here's a quick tour of how to create and edit your " +
          'site — you can stop anytime.',
      },
    },
    {
      element: at('studio-chat'),
      popover: {
        title: 'Ask the AI',
        description:
          'Tell the AI what you want in plain English — “add a section about me”, “use navy and ' +
          'gold”, “show my listings”. It builds and edits the page for you.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: at('studio-tabs'),
      popover: {
        title: 'Four ways to work',
        description:
          'Switch between AI Chat (talk to build), Structure (pages, menu and sections), Edit ' +
          '(fine-tune one section at a time) and Search (the title and description Google shows).',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: at('studio-page-selector'),
      popover: {
        title: 'Pick a page',
        description: 'Choose which page you’re editing — home, listings, about, and so on.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('studio-preview'),
      popover: {
        title: 'Live preview',
        description:
          'Your site updates here in real time as you build. Click any section in the preview to ' +
          'edit it directly.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: at('studio-device-toggle'),
      popover: {
        title: 'Check mobile',
        description:
          'Switch between desktop and phone views. Always check the phone view — most buyers visit ' +
          'on mobile.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('studio-undo'),
      popover: {
        title: 'Undo and redo',
        description: 'Changed your mind? Step back or forward through your recent edits.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('studio-history'),
      popover: {
        title: 'Version history',
        description:
          'Restore an earlier version of this page, or roll back the whole site, including pages ' +
          'you deleted. Restores land in your draft, so nothing changes live until you publish.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('studio-looks'),
      popover: {
        title: 'Looks',
        description: 'Try a different layout for your home, search and listing pages, and change your card styles.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('studio-publish'),
      popover: {
        title: 'Publish when ready',
        description:
          'Your edits stay private until you click Publish. Nothing goes live until you say so — ' +
          'so feel free to experiment.',
        side: 'bottom',
        align: 'end',
      },
    },
  ];
}
